import { FundAndPersonIdFilter, SeriesOfFund } from 'model/series';
import { action } from 'typesafe-actions';
import { GiroWebappError } from '../../../model/error';
import { NonParticipantOfFundActionTypes } from './types';

export const nonParticipantSeriesOfFundRequest = (filter: FundAndPersonIdFilter) => action(NonParticipantOfFundActionTypes.NON_PARTICIPANT_SERIES_OF_FUND_REQUEST, filter);
export const nonParticipantSeriesOfFundSuccess = (response: SeriesOfFund[]) => action(NonParticipantOfFundActionTypes.NON_PARTICIPANT_SERIES_OF_FUND_SUCCESS, response);
export const nonParticipantSeriesOfFundError = (error: GiroWebappError) => action(NonParticipantOfFundActionTypes.NON_PARTICIPANT_SERIES_OF_FUND_ERROR, error);
export const nonParticipantSeriesOfFundResetState = () => action(NonParticipantOfFundActionTypes.NON_PARTICIPANT_OF_FUND_RESET_STATE);
